module.exports = __webpack_public_path__ + "static/media/BS_F_Fashion_Necchi_blue_orange.b22c69b3.png";